export enum SubMenuTabellaDiServizioItemsEnum {
  GESTIONE_GENERICA_DOMINI = 'Gestione generica domini',
  GESTIONE_COMUNI_NASCITA_MORTE = 'Gestione comuni per i luoghi di nascita/morte',
  GESTIONE_LUOGHI_CODIFICATI_NASCITA = 'Gestione luoghi codificati di nascita',
  GESTIONE_LUOGHI_CODIFICATI_DECESSO = 'Gestione luoghi codificati di decesso',
  GESTIONE_AUTORITA_DECESSO = 'Gestione autorità di decesso',
  GESTIONE_CULTI_RELIGIOSI = 'Gestione culti religiosi codificati',
  GESTIONE_MINISTRI = 'Gestione ministri di culto',
}
